import { describeAuditAction, formatRelativeTime, type AuditTone } from '../lib/audit-format';

interface MasterAuditRowProps {
  action: string;
  workspaceName?: string | null;
  createdAt: string;
  metadata?: Record<string, unknown> | null;
  compact?: boolean;
}

function toneBg(tone: AuditTone): string {
  switch (tone) {
    case 'pass': return 'var(--pass-soft)';
    case 'block': return 'var(--block-soft)';
    case 'warn': return 'var(--warn-soft)';
    case 'info': return 'var(--info-soft)';
    default: return 'var(--card-soft)';
  }
}
function toneFg(tone: AuditTone): string {
  switch (tone) {
    case 'pass': return 'var(--pass)';
    case 'block': return 'var(--block)';
    case 'warn': return 'var(--warn)';
    case 'info': return 'var(--info)';
    default: return 'var(--fg-muted)';
  }
}

export function MasterAuditRow({ action, workspaceName, createdAt, metadata }: MasterAuditRowProps) {
  const d = describeAuditAction(action, metadata);
  const Icon = d.icon;
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
      <span
        style={{
          width: 32,
          height: 32,
          borderRadius: 9,
          background: toneBg(d.tone),
          color: toneFg(d.tone),
          display: 'grid',
          placeItems: 'center',
          flex: '0 0 32px',
        }}
      >
        <Icon size={15} strokeWidth={1.7} />
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 12.5, lineHeight: 1.35, color: 'var(--fg)' }}>{d.label}</div>
        <div
          style={{
            fontSize: 10,
            fontFamily: 'var(--font-mono)',
            color: 'var(--fg-muted)',
            marginTop: 2,
          }}
        >
          {workspaceName ? `${workspaceName} · ` : ''}{formatRelativeTime(createdAt)}
        </div>
      </div>
    </div>
  );
}
